import { Component } from '@angular/core';

@Component({
	selector: 'app-basic-settings',
	templateUrl: './basic-settings.component.html'
})
export class BasicSettingsComponent {}
